class Announcements {
  constructor() {
    // Support both local and staging IDs
    const id1 = 'kadence-conversion-422';
    const id2 = 'kadence-conversion-476';
    const id3 = 'kadence-conversion-470';
    this.bannerId = null;
    if (document.getElementById(id1)) {
      this.bannerId = id1;
    } else if (document.getElementById(id2)) {
      this.bannerId = id2;
    } else if (document.getElementById(id3)) {
      this.bannerId = id3;
    }
    this.toggleClass = 'kc-hidden';
    this.visibleClass = 'kc-visible';
    this.scrollPosition = 0;
    this.init();
  }

  init() {
    document.addEventListener('DOMContentLoaded', () => {
      console.log('[Announcements] Script recognized and loaded.');
      this.setupToggle();
    });
  }

  setupToggle() {
    if (!this.bannerId) return;
    const banner = document.getElementById(this.bannerId);
    if (!banner) return;

    // Ensure the banner is in the toggle off (hidden) position on load
    banner.classList.add(this.toggleClass);
    const inner = banner.querySelector('.kadence-conversion-inner');
    if (inner) {
      inner.style.padding = '0px';
      inner.style.minHeight = '0vh';
      inner.style.maxHeight = '0vh';
      inner.style.transition =
        'min-height 0.4s cubic-bezier(0.4,0,0.2,1), max-height 0.4s cubic-bezier(0.4,0,0.2,1), padding 0.4s cubic-bezier(0.4,0,0.2,1)';
      // Ensure overflow is hidden for smooth animation
      inner.style.overflow = 'hidden';
    }

    // Create a real button that follows the banner
    const toggleBtn = document.createElement('button');
    toggleBtn.setAttribute('aria-label', 'Toggle Announcements Banner');
    toggleBtn.style.position = 'absolute';
    toggleBtn.style.left = '25px';
    toggleBtn.style.top = '-50px';
    toggleBtn.style.zIndex = '400000001';
    toggleBtn.style.background = 'var(--global-palette-btn-bg)';
    toggleBtn.style.color = 'white';
    toggleBtn.style.fontWeight = 'bold';
    toggleBtn.style.fontSize = '1.2rem';
    toggleBtn.style.padding = '10px 24px';
    toggleBtn.style.border = 'none';
    toggleBtn.style.borderRadius = '6px';
    toggleBtn.style.cursor = 'pointer';
    toggleBtn.style.boxShadow = '0 2px 8px rgba(0,0,0,0.15)';
    toggleBtn.style.maxWidth = '95vw';
    toggleBtn.style.overflow = 'hidden';
    toggleBtn.style.whiteSpace = 'nowrap';

    // Responsive styles for mobile
    if (!document.getElementById('announcements-toggle-responsive-style')) {
      const style = document.createElement('style');
      style.id = 'announcements-toggle-responsive-style';
      style.textContent = `
        @media (max-width: 600px) {
          #${this.bannerId} > button[aria-label="Toggle Announcements Banner"] {
            font-size: 1rem !important;
            padding: 8px 10px !important;
            top: -44px !important;
            max-width: 90vw !important;
            left: 18px !important;
          }
        }
      `;
      document.head.appendChild(style);
    }

    // Add animated bell and text
    const bell = document.createElement('span');
    bell.className = 'announcement-bell-icon';
    bell.textContent = '🔔';
    bell.style.display = 'inline-block';
    bell.style.marginRight = '10px';
    bell.style.animation = '';

    const label = document.createElement('span');
    label.textContent = 'News & Announcements';

    toggleBtn.appendChild(bell);
    toggleBtn.appendChild(label);

    // Add bell keyframes if not present
    if (!document.getElementById('abell-shake-style')) {
      const style = document.createElement('style');
      style.id = 'abell-shake-style';
      style.textContent = `
        @keyframes abell-shake {
          0%, 100% { transform: rotate(0deg); }
          10% { transform: rotate(-15deg); }
          20% { transform: rotate(10deg); }
          30% { transform: rotate(-10deg); }
          40% { transform: rotate(6deg); }
          50% { transform: rotate(-4deg); }
          60% { transform: rotate(2deg); }
          70% { transform: rotate(-1deg); }
          80% { transform: rotate(1deg); }
          90% { transform: rotate(0deg); }
        }
        .announcement-bell-icon.is-open img.emoji {
          filter: brightness(0) invert(1);
        }
      `;
      document.head.appendChild(style);
    }

    // Bell animation: repeat every 6s, stop when banner is open
    let bellAnimationInterval = null;
    function startBellAnimation() {
      bell.style.animation =
        'abell-shake 2s cubic-bezier(.36,.07,.19,.97) both';
      setTimeout(() => {
        bell.style.animation = '';
      }, 2000);
    }
    function scheduleBellAnimation() {
      if (bellAnimationInterval) clearInterval(bellAnimationInterval);
      bellAnimationInterval = setInterval(() => {
        if (banner.classList.contains('kc-hidden')) {
          startBellAnimation();
        }
      }, 6000);
    }
    // Initial bell animation
    startBellAnimation();
    scheduleBellAnimation();

    // Insert the toggle button as the first child (do not force position: relative)
    banner.insertBefore(toggleBtn, banner.firstChild);

    toggleBtn.addEventListener('click', () => {
      console.log('[Announcements] Toggle Announcements Banner clicked');
      const inner = banner.querySelector('.kadence-conversion-inner');
      // If banner is hidden, show it and ensure .kc-visible is present
      if (banner.classList.contains(this.toggleClass)) {
        banner.classList.remove(this.toggleClass);
        // if (!banner.classList.contains(this.visibleClass)) {
        //   banner.classList.add(this.visibleClass);
        // } else {
        //   console.log('[Announcements] .kc-hidden is present');
        // }
        // Set styles for expanded state
        if (inner) {
          // Animate to expanded
          inner.style.padding = '30px';
          inner.style.minHeight = '75vh';
          inner.style.maxHeight = '100vh';
        }
        // Stop bell animation when open
        bell.style.animation = '';
        bell.textContent = '✖';
        bell.classList.add('is-open');
        this.scrollPosition = window.pageYOffset;
        document.body.classList.add('announcement-is-open');
        document.body.style.top = `-${this.scrollPosition}px`;
      } else {
        // If banner is visible, hide it (do not remove .kc-visible here)
        banner.classList.add(this.toggleClass);
        // Animate to collapsed
        if (inner) {
          inner.style.padding = '0px';
          inner.style.minHeight = '0vh';
          inner.style.maxHeight = '0';
        }
        // Resume bell animation when closed
        bell.textContent = '🔔';
        bell.classList.remove('is-open');
        document.body.classList.remove('announcement-is-open');
        document.body.style.top = '';
        window.scrollTo(0, this.scrollPosition);
        startBellAnimation();
        scheduleBellAnimation();
      }
      // this.logVisibleState(banner);
    });

    // Initial log
    // this.logVisibleState(banner);
  }

  // logVisibleState(banner) {
  //   if (banner.classList.contains(this.visibleClass)) {
  //     console.log(
  //       '[Announcements] .kc-visible is PRESENT on .kadence-conversion-wrap',
  //     );
  //   } else {
  //     console.log(
  //       '[Announcements] .kc-visible is NOT present on .kadence-conversion-wrap',
  //     );
  //   }
  // }
}

export default Announcements;
